import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DocumentosApiClient from '@/core/apiclient/documentos/DocumentosApiClient'
import { DownloadFile } from '@/core/utils'
import api from '@/core/apiclient'

function createApiClient(tipo) {
	const urlBuilder = new DocumentosUrlBuilder(tipo)
	return new DocumentosApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.BUSCA_PAGINADA_GENERICA](context, objBusca) {
		const apiClient = createApiClient(objBusca.tipo)
		let { data } = await apiClient.buscaPaginada(objBusca.idEntidade, objBusca.filtro, objBusca.paginacao)
		return data
	},
	async [actionTypes.DOCUMENTOS.EXCLUIR_DOCUMENTO_GENERICO](context, objExcluir) {
		const apiClient = createApiClient(objExcluir.tipo)
		let { data } = await apiClient.excluir(objExcluir.idEntidade, getFiltroExcluirDocumentoGenerico(objExcluir))
		return data
	},
	async [actionTypes.DOCUMENTOS.BAIXAR_DOCUMENTO_GENERICO](context, objBaixar) {
		const apiClient = createApiClient(objBaixar.tipo)
		let response = await apiClient.baixar(objBaixar.idEntidade, getFiltroBaixarDocumentoGenerico(objBaixar))
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.DOCUMENTOS.CANCELAR_DOCUMENTO_GENERICO](context, objCancelar) {
		const apiClient = createApiClient(objCancelar.tipo)
		let { data } = await apiClient.cancelar(objCancelar)
		return data
	},
}

function getFiltroExcluirDocumentoGenerico(objExcluir) {
	return {
		tipoRegistroDocumento: objExcluir.documento.tipoRegistroDocumento,
	}
}

function getFiltroBaixarDocumentoGenerico(objBaixar) {
	return {
		tipoRegistroDocumento: objBaixar.documento.tipoRegistroDocumento,
		situacaoDocumento: objBaixar.documento.situacao,
	}
}
